<cxone-modal [headerTitle]="headerTitle" [modalSize]="'m'" [focusOnShow]="true"
    (dismissed)="cancel()" (closed)="save()" 
    [allowClose]="true" [cancelLabel]="cancelLabel" [saveLabel]="saveLabel"
    [saveDisabled]="loadFromFileForm.invalid || (fileValidation && !fileValidation.isValid)"
    #modalDialog>
    <cv-loader [loaderType]="'cxone'" *ngIf="loading || !isLocalizationSectionLoaded"></cv-loader>
    <div class="cxone-load-from-file-dialog-body" [formGroup]="loadFromFileForm" *ngIf="isLocalizationSectionLoaded">
        <div class="upload-section">
            <div class="input-header">
                <span class="label allCaps mandatory-field" cvLocalizedText langSection="ETL_Load_From_File" langKey="Upload_File">
                    Upload File
                </span>
            </div>
            <span class="info">
                {{infoMessage}}
            </span>
            <div class="d-flex radio mt-1">
                <cxone-radio type="radio" [labelText]="replaceRadioLabel" radioId="replace_fields" name="actions"
                    formControlName="uploadActions" value="replace" [checked]="true"></cxone-radio>
                <cxone-radio type="radio" [labelText]="addMissingRadioLabel" radioId="add_fields" name="actions"
                    formControlName="uploadActions" value="add" class="ml-2"></cxone-radio>
            </div>
            <button cvLocalizedText langSection="ETL_Load_From_File" langKey="Select_File" (click)="uploader.click()"
                class="cxone-btn btn-medium btn-secondary button-color btn-bg-is-white" tabindex="0">
                Select File
            </button>
            <div class="file-details-container">
                <cxone-selected-tags id="selected-file-name" [maxTagsToDisplay]="1"
                    [removable]="true" [tagsSource]="selectedFileName"
                    (tagDeleted)="clearFile(uploader)">
                </cxone-selected-tags>
                <cxone-embedded-messages *ngIf="fileValidation && !fileValidation.isValid && fileValidation.warningMessage"
                    messageType="user-warning" [messageData]="fileValidation.warningMessage" id="user-warning">
                </cxone-embedded-messages>
                <cxone-embedded-messages *ngIf="fileValidation && !fileValidation.isValid && fileValidation.errorMessage"
                    messageType="user-error" [messageData]="fileValidation.errorMessage" id="user-error">
                </cxone-embedded-messages>
            </div>
            <input hidden formControlName="file" type="file" accept=".txt, .json" 
                (change)="validateAndLoadFile($event)" #uploader/>
        </div>
        <cv-load-from-file-tree></cv-load-from-file-tree>
    </div>
</cxone-modal>
